import { ProSidebarProvider } from 'react-pro-sidebar';
import { Loading } from '@doist/reactist';
import '@doist/reactist/styles/reactist.css';
import '@doist/reactist/styles/loading.css';
import App from './App'
import Login from './pages/Login/Login';
import useAuth from './hooks/useAuth';
import { useEffect } from 'react';
import { useLocation } from 'react-use';
import Signup from './pages/Signup/Signup';

function Auth() {
    const {data, isLoading } = useAuth();
    const location = useLocation();
    console.log(location.pathname);

    useEffect(() => {
        if (!isLoading && window.location.hash.length > 0 && data?.status !== 'success') {
            window.location.hash = '';
        }
    }, [data?.status, isLoading]);

    if (isLoading) return <div className="mainSpinner"><Loading size="large" /></div>;

    if (location.pathname.match(/^\/signup\/.*/)) {
        return <Signup />;
    }

    if (data?.status !== 'success') {
        return <Login />;
    }

    return (
        <>
            <ProSidebarProvider>
                <App />
            </ProSidebarProvider>
        </>
    );
};

export default Auth;
